module.exports = __webpack_public_path__ + "media/images/icons/icon-product_8-25b30b49b4604d3cc12a92f8fda7394d.svg";